import React from "react";
import { actionsButtonDependsOnType } from "../../common/types/common";

interface ActionsMenuButtonProps {
	actionsButtonDependsOn?: actionsButtonDependsOnType;
	name?: string;
	onClick: React.MouseEventHandler<HTMLButtonElement>;
	type?: string;
}

export function ActionsMenuButton({
	actionsButtonDependsOn,
	onClick,
	name = "More",
	type = "btn--more",
}: ActionsMenuButtonProps) {
	const showActionsButton = actionsButtonDependsOn
		? Object.entries(actionsButtonDependsOn)
				.map(([key, value]) => value()[key])
				.every((v) => v === true)
		: true;

	if (!showActionsButton) {
		return null;
	}

	return (
		<button
			type="button"
			className={`btn btn--secondary btn--icon btn--icon--lg ${type}`}
			onClick={onClick}
		>
			<span>{name}</span>
		</button>
	);
}
